import { render, staticRenderFns } from "./curriculumList_edit.vue?vue&type=template&id=b08ecc9e&scoped=true&"
import script from "./curriculumList_edit.vue?vue&type=script&lang=js&"
export * from "./curriculumList_edit.vue?vue&type=script&lang=js&"
import style0 from "./curriculumList_edit.vue?vue&type=style&index=0&id=b08ecc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08ecc9e",
  null
  
)

export default component.exports